var React = require('react');

function InfoQrcode (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 10.286H10.286V0H0V10.286ZM3.429 3.429H6.857V6.857H3.429V3.429ZM13.714 0V10.286H24V0H13.714ZM20.571 6.857H17.143V3.429H20.572L20.571 6.857ZM0 24H10.286V13.714H0V24ZM3.429 17.143H6.857V20.572H3.429V17.143ZM22.286 13.714H24V20.571H18.857V18.857H17.143V24H13.714V13.714H18.857V15.428H22.286V13.714ZM22.286 22.285H24V24H22.286V22.285ZM18.857 22.285H20.571V24H18.857V22.285Z","fill":"#212121"}));
}

InfoQrcode.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = InfoQrcode;

InfoQrcode.default = InfoQrcode;
